export default function (discount) {
  if (!discount) return null;
  if (String(discount).endsWith("%")) return discount;
  else return `${discount}%`;
}
